export default __webpack_public_path__ + "static/media/pandemic-stories-logo.990c78d0.png";